<div class="deliverable-template-container">
  <div class="deliverables-container ag-theme-alpine">
    <motif-card
      *ngFor="let template of workspaceTemplates; trackBy: trackByTemplateGuid"
      class="deliverable-card w-100 gap-0"
      [class.expanded]="template.expanded">
      <!-- Card Header -->
      <div class="card-header" (click)="toggleDeliverable(template)">
        <div class="header-left">
          <button motifIconButton type="undefined" class="del-expand-btn" [class.expanded]="template.expanded">
            <motif-icon
              *ngIf="!template.expanded"
              [iconFunction]="arrowCollapseIcon"
              size="32"></motif-icon>
            <motif-icon
              *ngIf="template.expanded"
              [iconFunction]="arrowExpandIcon"
              size="32"></motif-icon>              
          </button>
          <span class="deliverable-title">{{
            template.workSpaceTemplateName
          }}</span>
          <span class="deliverable-type-pill motif-overline-italic-light" [attr.aria-label]="template.deliverableType?.deliverableTypeName + ' deliverable type'">{{
            template.deliverableType?.deliverableTypeName
          }}</span>
        </div>

        <div class="header-right">
          <div class="stats">
            <div class="stat-item milestones">
              <span
                ><img
                  class="process-milestone-icon"
                  src="assets/images/milestone-icon.svg"                   
                  alt="Milestone" />
                <span class="motif-caption-default-light"
                  >Milestones:
                  {{ getTemplateCounts(template).milestones }}</span
                ></span
              >
            </div>
            <div class="stat-item tasks">
              <span
                ><img
                  class="process-milestone-icon task-icon-img"
                  src="assets/images/task-icon.svg"
                  alt="Task" />
                <span class="motif-caption-default-light"
                  >Tasks: {{ getTemplateCounts(template).tasks }}</span
                >
              </span>
              <!-- Tasks: {{ deliverable.tasksCount }} -->
            </div>
          </div>
        </div>
      </div>

      <!-- Expanded Content -->
      <div class="card-content" *ngIf="template.expanded">
        <motif-table
          id="workspaceTemplateItemGrid"
          class ="borderless-table"
          [columnDefs]="columnHeaders"
          [rowData]="template.rowData || []"
          [gridOptions]="getGridOptions(template)"
          (gridReady)="handleGridReady($event, template)"
          [suppressRowHoverHighlight]="true"
          [getRowClass]="getRowClass"></motif-table>
        <!-- Empty state -->
        <div
          class="empty-state"
          *ngIf="
            !template.workspaceTemplateItems ||
            template.workspaceTemplateItems.length === 0
          ">
          <p class="motif-caption-default-light pt-4 pb-4">No deliverable items yet. Click the + button to add one.</p>
        </div>
      </div>
    </motif-card>
    <app-confirm-dialog
      #confirmDialog
      acceptLabel="Proceed"
      rejectLabel="Cancel"
      (onConfirm)="handleConfirmDelete()"
      (onReject)="handleRejectDelete()">
    </app-confirm-dialog>
  </div>

  <!-- Empty state for no deliverables -->
  <div class="no-deliverables" *ngIf="!workspaceTemplates || workspaceTemplates.length === 0">    
    <div class="motif-display-2-light mb-5 pb-2">(o_o)</div>
    <h3 class="motif-h2-default-light mb-2">No deliverables found</h3>
    <p class="motif-body1-default-light mb-5 pb-2">Get started by adding your first deliverable.</p>
    <!-- <button motifButton color="primary" size="small" (click)="addDeliverable()">
      + Add Deliverable
    </button> -->
</div>
